import React from "react";
import { Text, Heading as H } from "rebass";
import { css } from "styled-components";
import PropTypes from "prop-types";

const childrenPropTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

export const Bold = ({ children, ...rest }) => (
  <Text as="strong" {...rest}>
    {children}
  </Text>
);

export const Paragraph = ({ children, ...rest }) => (
  <Text as="p" {...rest}>
    {children}
  </Text>
);

export const Heading = ({ children, ...rest }) => (
  <H
    fontFamily="regular"
    color="red"
    fontSize={[7, 5, 5, 4, 7]}
    fontWeight="bold"
    lineHeight="1.1"
    textAlign="right"
    as="h1"
    css={css`
      text-transform: uppercase;
      margin: 1.4em 0;
      word-break: break-word;
    `}
    {...rest}
  >
    {children}
  </H>
);

Heading.propTypes = {
  ...childrenPropTypes
};

export const BigLetters = ({ children, ...rest }) => (
  <Text
    fontFamily="regular"
    color="red"
    fontSize={[4, 5, 6, "70px"]}
    fontWeight="bold"
    textAlign="right"
    letterSpacing="2px"
    {...rest}
    css={css`
      text-transform: uppercase;
      line-height: 1.1;
      margin-bottom: 0.65em;
      padding-top: 0.175em;
      display: block;
      word-break: break-word;
      a {
        text-decoration: none;
        color: inherit;
        display: block;
        padding: 0 20px;
        transition: color 150ms ease-in-out;

        &:hover {
          color: ${props => props.theme.colors.redIntense};
        }
      }
    `}
  >
    {children}
  </Text>
);

Bold.propTypes = {
  ...childrenPropTypes
};

Paragraph.propTypes = {
  ...childrenPropTypes
};

BigLetters.propTypes = {
  ...childrenPropTypes
};
